import { Box, Typography } from '@mui/material';
import theme from '../../../theme';

const CATEGORY_LABELS = {
  Reviews: '리뷰',
  News: '뉴스',
  Lists: '플리',
  Mixes: '플리',
  Notice: '공지',
  Notices: '공지',
  Albums: '앨범',
};

const CategoryTag = ({ category, sx }) => {
  const displayCategory = CATEGORY_LABELS[category] || category;

  return (
    <Box
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: '#FFF2EE',
        padding: '4px 6px',
        borderRadius: '2px',
        ...sx,
      }}
    >
      <Typography
        sx={{
          color: theme.palette.secondary.main,
          fontSize: { xs: '12px', md: '13px' },
          fontWeight: '700',
          lineHeight: 'normal',
        }}
      >
        {displayCategory}
      </Typography>
    </Box>
  );
};

export default CategoryTag;
